module.exports = __webpack_public_path__ + "static/Bertelsmann-Stiftung-5935beb7ba3678db979dc7ee1114c86e.png";